function SettingsPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      <div className="max-w-2xl space-y-6">
        {/* API Configuration */}
        <section className="bg-card border border-border rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-4">API Configuration</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">API Server URL</label>
              <input
                type="text"
                defaultValue="http://localhost:8000"
                className="w-full px-3 py-2 bg-secondary border border-input rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Tenant ID</label>
              <input
                type="text"
                defaultValue="local_default"
                className="w-full px-3 py-2 bg-secondary border border-input rounded-md"
              />
            </div>
          </div>
        </section>

        {/* Display Options */}
        <section className="bg-card border border-border rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-4">Display Options</h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">Grid Size</div>
                <div className="text-sm text-muted-foreground">Number of columns in the image grid</div>
              </div>
              <select className="bg-secondary border border-input rounded-md px-3 py-1.5">
                <option>Auto</option>
                <option>3 columns</option>
                <option>4 columns</option>
                <option>5 columns</option>
                <option>6 columns</option>
              </select>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">Show Captions</div>
                <div className="text-sm text-muted-foreground">Display captions below thumbnails</div>
              </div>
              <input type="checkbox" className="w-5 h-5 rounded" />
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">Show Tags</div>
                <div className="text-sm text-muted-foreground">Display tags below thumbnails</div>
              </div>
              <input type="checkbox" className="w-5 h-5 rounded" />
            </div>
          </div>
        </section>

        {/* Export Settings */}
        <section className="bg-card border border-border rounded-lg p-4">
          <h2 className="text-lg font-semibold mb-4">Export Settings</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Default Export Path</label>
              <input
                type="text"
                placeholder="/path/to/exports"
                className="w-full px-3 py-2 bg-secondary border border-input rounded-md"
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">Include Metadata</div>
                <div className="text-sm text-muted-foreground">Export manifest.json with each album</div>
              </div>
              <input type="checkbox" defaultChecked className="w-5 h-5 rounded" />
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default SettingsPage
